import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import UsuariosList from './list/UsuariosList';
import UsuariosItemActions from './list/components/UsuariosItemActions';

class Usuarios extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Usuarios');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/app/usuarios/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;

    return (
      <div>
        <Row className="mb-3">
          <Col>
            {Guardian.allows('usuario.crear') && (
              <Link
                to="/app/usuarios/registrar"
                className="mr-3"
              >
                <Button>Nuevo Usuario</Button>
              </Link>
            )}

            {selectedRowKeys.length > 0 && (
              <UsuariosItemActions
                selectedRowKeys={selectedRowKeys}
                selectedRows={selectedRows}
                onActionComplete={this.handleOnRowSelectionChange}
              />
            )}
          </Col>

          <Col className="text-right">
            <h5 className="pt-2">Usuarios</h5>
          </Col>
        </Row>

        {Guardian.allows('usuario.listar') && (
          <UsuariosList
            selectedRowKeys={selectedRowKeys}
            selectedRows={selectedRows}
            onRowClick={this.handleOnRowClick}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </div>
    );
  }
}

export default Usuarios;
